import { levelTestTheme } from "./theme.config.js";
const assetBase = "/assets/quizzes/level-test";
export const levelTestQuiz = {
    id: "linear-level-test",
    slug: "level-test",
    version: 1,
    metadata: {
        name: "Quick Level Test",
        language: "en",
        description: "Short linear quiz used to prove multi-quiz isolation and linear progress."
    },
    startQuestionId: "comfort",
    start: {
        enabled: true,
        renderer: "custom-html",
        mode: "first-question",
        layout: "centered",
        eyebrow: "Quick check",
        title: "Find your English starting point",
        subtitle: "A compact linear quiz with the same shared engine.",
        cta: { label: "Start", action: "startQuiz" },
        media: { type: "image", src: `${assetBase}/hero.svg`, alt: "Abstract English level cards" },
        background: { type: "color", value: "#2557d6" },
        logo: { enabled: false },
        customHtml: {
            htmlUrl: `${assetBase}/start/start.html`,
            cssUrls: [`${assetBase}/start/start.css`],
            fallback: "native"
        }
    },
    landing: { enabled: false, sections: [] },
    progress: { mode: "linear", capFinalQuestionAt99: true },
    phone: { defaultCountry: "CZ", preferredCountries: ["CZ", "UA", "PL", "DE"], searchable: true },
    questions: [
        {
            id: "comfort",
            type: "single-choice",
            title: "How comfortable are you speaking English?",
            answers: [
                { id: "low", label: "I avoid speaking", scores: { beginner: 4 } },
                { id: "medium", label: "I can handle simple topics", scores: { speaking: 3 } },
                { id: "high", label: "I speak often but need polish", scores: { business: 3 } }
            ]
        },
        {
            id: "grammar",
            type: "single-choice",
            title: "What happens with grammar under pressure?",
            answers: [
                { id: "lost", label: "I get lost quickly", scores: { beginner: 3 } },
                { id: "basic", label: "Basic structures are okay", scores: { speaking: 2 } },
                { id: "precise", label: "I need more precision", scores: { business: 2, exam: 1 } }
            ]
        },
        {
            id: "goal",
            type: "single-choice",
            title: "What is your nearest goal?",
            answers: [
                { id: "base", label: "Build a stable base", scores: { beginner: 3 } },
                { id: "talk", label: "Speak more naturally", scores: { speaking: 4 } },
                { id: "work", label: "Use English professionally", scores: { business: 4 } }
            ]
        },
        {
            id: "pace",
            type: "single-choice",
            title: "What pace feels realistic?",
            answers: [
                { id: "calm", label: "Calm and steady", next: "__end__", scores: { beginner: 1 } },
                { id: "regular", label: "Regular weekly practice", next: "__end__", scores: { speaking: 1 } },
                { id: "intense", label: "Intensive sprint", next: "__end__", scores: { business: 1, exam: 1 } }
            ]
        }
    ],
    scoring: {
        categories: ["business", "speaking", "beginner", "exam"],
        normalizeTo: 100,
        tieBreaker: ["business_level", "speaking_level", "starter_level"],
        rules: [
            {
                id: "low_comfort_starter_override",
                when: { type: "answerEquals", questionId: "comfort", answerId: "low" },
                effect: { type: "boost", category: "beginner", value: 2 },
                reason: "low-comfort"
            }
        ]
    },
    results: [
        {
            id: "business_level",
            category: "business",
            title: "Professional Track",
            description: "You are ready to aim at professional fluency.",
            preview: "Focus on meetings, writing and confident workplace phrases.",
            gatedContent: "Full plan: workplace vocabulary, role plays and weekly speaking review.",
            priority: 3
        },
        {
            id: "speaking_level",
            category: "speaking",
            title: "Speaking Track",
            description: "Conversation practice should be your main engine.",
            preview: "Focus on short, frequent speaking sessions.",
            gatedContent: "Full plan: conversational drills, phrase banks and guided correction.",
            priority: 2
        },
        {
            id: "starter_level",
            category: "beginner",
            title: "Foundation Track",
            description: "A stronger base will make every next step easier.",
            preview: "Focus on grammar basics and simple confident answers.",
            gatedContent: "Full plan: core grammar, everyday phrases and short dialogues.",
            priority: 1
        }
    ],
    analysis: {
        durationMs: 1600,
        reducedMotionDurationMs: 300,
        steps: ["Checking answers...", "Calculating scores...", "Preparing result..."],
        checkpoints: [0, 25, 51, 76, 100]
    },
    leadForm: {
        title: "Send me the full level summary",
        fields: {
            name: { enabled: true, required: false, label: "Name" },
            phone: { enabled: true, required: true, label: "Phone" },
            email: { enabled: true, required: true, label: "Email" }
        },
        privacyConsentRequired: true,
        marketingConsentEnabled: false,
        submitLabel: "Get summary"
    },
    theme: levelTestTheme
};
export const directStartQuiz = {
    ...levelTestQuiz,
    id: "direct-start-level-test",
    slug: "direct-start",
    metadata: {
        ...levelTestQuiz.metadata,
        name: "Direct Start Level Test",
        description: "Start-disabled fixture that enters the first question immediately."
    },
    start: {
        ...levelTestQuiz.start,
        enabled: false,
        renderer: "none",
        title: "Direct question start",
        customHtml: undefined
    }
};
export const customFallbackQuiz = {
    ...levelTestQuiz,
    id: "custom-fallback-level-test",
    slug: "custom-fallback",
    metadata: {
        ...levelTestQuiz.metadata,
        name: "Custom Fallback Level Test",
        description: "Custom HTML fallback fixture."
    },
    start: {
        ...levelTestQuiz.start,
        renderer: "custom-html",
        mode: "first-question",
        title: "Fallback start renderer",
        customHtml: {
            htmlUrl: "/assets/quizzes/level-test/start/missing.html",
            cssUrls: ["/assets/quizzes/level-test/start/missing.css"],
            fallback: "native"
        }
    }
};
